// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"usbAttack__wrapper"};